<template>
    <div>
        <el-form :model="payPhaseTpl" :rules="payPhaseTplCheck" ref="payPhaseTplInfo" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label left">
                        <label class="required">模板名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="name">
                            <el-input class="width-2x" v-model="payPhaseTpl.name"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <el-form :model="payPhaseTpl" ref="payPhaseTplItemList" class="demo-ruleForm">
            <table class="custom-tbl error-prompt">
                <thead class="head">
                <tr class="row">
                    <th class="required" width="200">阶段名称</th>
                    <th class="required">支付比例(%)</th>
                    <th width="300">备注</th>
                    <th width="150">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-for="(item,index) in payPhaseTpl.itemList" class="row">
                    <td>
                        <el-form-item :key="item.id" :prop="'itemList.' + index + '.name'">
                            <el-input v-model="item.name" @blur="changName(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item :key="item.id" :prop="'itemList.' + index + '.ratio'">
                            <el-input v-model="item.ratio" @blur="changRatio(index)"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item :key="item.id" :prop="'itemList.' + index + '.desc'">
                            <el-input v-model="item.desc"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <div @click="removeItem(index);" class="swb-btn swb-btn-link" v-if="index > 1">移除</div>
                    </td>
                </tr>
                </tbody>
                <tfoot class="foot">
                <tr class="row">
                    <td colspan="4" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;">
                        <div @click="addItem();" class="swb-btn swb-btn-link">
                            <i class="icon iconfont icon-jiahao mr5"></i>
                            <a>添加</a>
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>
        </el-form>
        <div class="simple-form">
            <div class="form-group">
                <div class="form-label left">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-input class="width-2x" type="textarea" v-model="payPhaseTpl.desc" :rows="3" :maxlength="120"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { loadAssetDeprMethodList } from '../retailer/asset-comn'

    import finacApi from '../../api/finac'

    export default{
        name: 'swb-pay-phase-tpl-save',
        desc: '付款阶段模板保存',
        props: {
            tplId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                payPhaseTpl: {
                    itemList: [],
                },
            }
        },
        created: function () {
            if(!Utils.isNoB(this.tplId)) {
                this.getPayPhaseTplDetail();
            } else {
                this.addItem();
                this.addItem();
            }
        },
        methods: {
            getPayPhaseTplDetail: function () {
                let self = this;
                let postData = {};
                postData.tplId = self.tplId;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getPayPhaseTplById(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let payPhaseTpl = result.data;
                        let itemList = payPhaseTpl.itemList || [];
                        itemList.forEach(function (item) {
                            item.ratio = parseFloat(item.ratio).toFixed(2);
                        })
                        self.payPhaseTpl = Utils.merge({}, payPhaseTpl);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            addItem: function () {
                let payPhaseTpl = this.payPhaseTpl;
                let itemList = payPhaseTpl.itemList || [];
                //
                let item = {
                    name: null,
                    ratio: null,
                    desc: null,
                };
                itemList.push(item);
                this.payPhaseTpl = Utils.merge({}, payPhaseTpl);
            },
            changName: function (index) {
                let payPhaseTpl = this.payPhaseTpl;
                let itemList = payPhaseTpl.itemList || [];
                let item = itemList[index];
                item.name.trim();
                let nameList = itemList.pluck("name").sort();
                for(var i = 0; i < nameList.length; i++) {
                    if(nameList[i] == nameList[i + 1]) {
                        let name = nameList[i] != null ? nameList[i] : null;
                        if(!Utils.isNoB(name)){
                            MsgBox.warning("阶段名称重复" + name);
                            return;
                        }
                    }
                }
            },
            changRatio: function (index) {
                let payPhaseTpl = this.payPhaseTpl;
                let itemList = payPhaseTpl.itemList || [];
                let item = itemList[index];
                if(!Utils.isNoB(item.ratio) && Utils.isMoneyStr(item.ratio)) {
                    let ratio = parseFloat(item.ratio);
                    if(ratio >= 100) {
                        item.ratio = null;
                    } else {
                        ratio = ratio.toFixed(2);
                        item.ratio = ratio;
                    }
                } else {
                    item.ratio = null;
                }
            },
            removeItem: function (index) {
                let payPhaseTpl = this.payPhaseTpl;
                let itemList = payPhaseTpl.itemList || [];
                itemList.splice(index, 1);
                this.payPhaseTpl = Utils.merge({}, payPhaseTpl);
            }
            ,
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                let payPhaseTpl = self.payPhaseTpl;
                let message = "";
                let submitFlag = true;
                if(Utils.isNoB(payPhaseTpl.name)) {
                    message = "模板名称不可为空";
                    submitFlag = false;
                }
                let itemList = payPhaseTpl.itemList || [];
                if(itemList.length < 2){
                    message = "至少设置2个阶段";
                    submitFlag = false;
                }
                let sumRatio = 0;
                let nameList = itemList.pluck("name").sort();
                if(submitFlag) {
                    if(nameList.length > 0) {
                        for(let i = 0; i < nameList.length; i++) {
                            if(!Utils.isNoB(nameList[i])) {
                                if(nameList[i] == nameList[i + 1]) {
                                    let name = nameList[i] != null ? nameList[i] : null;
                                    if(!Utils.isNoB(name)){
                                        message = "阶段名称重复" + name;
                                        submitFlag = false;
                                    }

                                }
                            }
                        }
                    }

                    if(submitFlag) {
                        for(let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            if(Utils.isNoB(item.name)) {
                                message = "阶段名称不可为空";
                                submitFlag = false;
                            }
                            if(Utils.isNoB(item.ratio)) {
                                message = item.name + "支付金额不可为空";
                                submitFlag = false;
                            } else {
                                sumRatio = parseFloat(sumRatio) + parseFloat(item.ratio);
                            }
                        }
                        if(sumRatio > 100) {
                            message = "支付比例不能超过100%";
                            submitFlag = false;
                        }
                        if(sumRatio < 100) {
                            message = "支付比例不能小于100%";
                            submitFlag = false;
                        }
                    }
                }

                if(Utils.isTrue(submitFlag)) {
                    result.type = "info";
                    result.data = payPhaseTpl;
                } else {
                    result.type = "warn";
                    result.message = message;
                }
                return result;
            },
        },

    }
</script>



// WEBPACK FOOTER //
// src/compo/payPhase/PayPhaseTplSave.vue